module.exports = __webpack_public_path__ + "img/MemeETC (13).63311ba9.jpeg";